import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../tokens/api-tokens';
import {
  AssignableAttorneyRolesResponse,
  LawFirmCreateUserResponseDto,
  LawFirmOfficesApiResponse,
  LawFirmUserResponse,
  LawFirmUsersResponse,
  UpsertLawFirmUserDto
} from '../models/law-firm-user.model';

@Injectable({ providedIn: 'root' })
export class LawFirmUserService {
  private http = inject(HttpClient);
  private apiUrl = inject(API_BASE_URL);

  getUsers(firmId: number): Observable<LawFirmUsersResponse> {
    return this.http.get<LawFirmUsersResponse>(`${this.apiUrl}/law-firm/${firmId}/users`);
  }

  getUser(firmId: number, portalUserId: string): Observable<LawFirmUserResponse> {
    return this.http.get<LawFirmUserResponse>(`${this.apiUrl}/law-firm/${firmId}/users/${portalUserId}`);
  }

  createUser(firmId: number, body: UpsertLawFirmUserDto): Observable<LawFirmCreateUserResponseDto> {
    return this.http.post<LawFirmCreateUserResponseDto>(`${this.apiUrl}/law-firm/${firmId}/users`, body);
  }

  updateUser(firmId: number, portalUserId: string, body: UpsertLawFirmUserDto): Observable<LawFirmUserResponse> {
    return this.http.put<LawFirmUserResponse>(`${this.apiUrl}/law-firm/${firmId}/users/${portalUserId}`, body);
  }

  setStatus(firmId: number, portalUserId: string, active: boolean): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/law-firm/${firmId}/users/${portalUserId}/status`, { active });
  }

  getOffices(firmId: number): Observable<LawFirmOfficesApiResponse> {
    return this.http.get<LawFirmOfficesApiResponse>(`${this.apiUrl}/law-firm/${firmId}/offices`);
  }

  getAssignableRoles(firmId: number): Observable<AssignableAttorneyRolesResponse> {
    return this.http.get<AssignableAttorneyRolesResponse>(`${this.apiUrl}/law-firm/${firmId}/roles`);
  }
}
